import React, { ReactElement } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/pl';

import type { ReviewStatsMonthlyInterface } from 'interfaces/review-stats.interface';
import { ReviewRatingBreakpoints } from 'components/review/review-filter/review-rating-filter';
import { currency } from 'helpers/number';

import './chart-item.scss';

dayjs.locale('pl');

enum BarStyle {
    positive = 'blue',
    neutral = 'orange',
    negative = 'red',
    unknown = 'grey'
}

const CompanyViewCardRatingChartItem: React.FC<{ data: ReviewStatsMonthlyInterface; }> = ({ data }): ReactElement => {
    const height = data.averageRating < 0 ? 100 : Math.round(100 * data.averageRating / 5);
    let barStyle: BarStyle = BarStyle.positive;

    if (data.averageRating < 0) {
        barStyle = BarStyle.unknown;
    } else if (data.averageRating < ReviewRatingBreakpoints.negative) {
        barStyle = BarStyle.negative;
    } else if (data.averageRating < ReviewRatingBreakpoints.positive) {
        barStyle = BarStyle.neutral;
    }

    const month = dayjs().year(data.year).month(data.month - 1).format('MMM');

    return (
        <div className="company-view-card__rating-chart-item">
            <div className="company-view-card__rating-chart-value">
                {data.averageRating >= 0
                    ? currency(data.averageRating, 2)
                    : (
                        <>
                            &nbsp;
                        </>
                    )}
            </div>
            <div className="company-view-card__rating-chart-bar-container">
                <div className={`company-view-card__rating-chart-bar company-view-card__rating-chart-bar-${barStyle}`} style={{ height: `${height}%` }} />
            </div>
            <div className="company-view-card__rating-chart-label">
                {month}
            </div>
        </div>
    );
};

export default CompanyViewCardRatingChartItem;
